/**
 * Presence-Aware Textarea Component
 *
 * Textarea field with presence indicators showing who is currently editing.
 * Extends shadcn/ui Textarea component with collaboration features.
 */

import * as React from "react"
import { Textarea } from "./textarea"
import { cn } from "../../lib/utils"
import { PresenceBadge, getPresenceFieldStyle } from "./presence-badge"

const PresenceTextarea = React.forwardRef(
  ({
    className,
    editor = null, // { user_id, user_name, user_initials, timestamp }
    isCurrentUser = false,
    ...props
  }, ref) => {
    const showPresence = editor && !isCurrentUser;

    return (
      <div className="relative w-full">
        <Textarea
          ref={ref}
          className={cn("transition-shadow duration-200", className)}
          // Only styled while someone else holds the field, so the component's
          // own focus-visible ring is left intact the rest of the time.
          style={showPresence ? getPresenceFieldStyle(editor.user_id) : undefined}
          {...props}
        />

        {showPresence && <PresenceBadge editor={editor} />}
      </div>
    )
  }
)

PresenceTextarea.displayName = "PresenceTextarea"

export { PresenceTextarea }
